// extracted by mini-css-extract-plugin
export default {"cat1":"Group_cat1__PIV5I","cat2":"Group_cat2__iC89a","cat3":"Group_cat3__znVc8","categoly":"Group_categoly__4odsU"};